import { AuthStoreType } from '@/types/store/auth-store.type';

export const state: AuthStoreType = {
  currentUser: null,
};
